export const validateUuid = (value?: string) => {
  if (!value) {
    return false
  }
  const uuidV4Regex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi
  return uuidV4Regex.test(value)
}
